import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Breadcrumb from "../layouts/Breadcrumb";
import Header from '../layouts/Headerthree';
import Footer from '../layouts/Footerthree';
import Content from '../sections/About/Content';

class About extends Component {
    render() {
        
        return (
            <Fragment>
                <MetaTags>
                    <title>Onitir | About</title>
                    <meta
                        name="description"
                        content="#"
                    />
                </MetaTags>
                <Header />
                <Breadcrumb breadcrumb={{pagename:'About Us'}} />
                <Content/>
                <Footer />
            </Fragment>
        );
    }
}

export default About;